module.exports = __webpack_public_path__ + "static/media/banner_confer.b45c7687.jpg";